export default __webpack_public_path__ + "static/media/bg.6b6b25df.jpg";